export const COLUMN_WIDTH_SET = 'COLUMN_WIDTH_SET';
export const COLUMN_WIDTHS_REMOVE = 'COLUMN_WIDTHS_REMOVE';
